// export default MY_HR_GET_JOB_CLASS_GROUPS = gql`
import gql from "graphql-tag";

export const MY_HR_JOB_CLASS_GROUPS_SUBSCRIPTION = gql`
  subscription jobClassGroups(
    $searchField: String
    $searchText: String
    $sort: String
    $page: Int
    $pageSize: Int
  ) {
    jobClassGroups(
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      page: $page
      pageSize: $pageSize
    ) {
      availableList {
        _id
        code
        name
      }
      selectedList {
        _id
        code
        name
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;
